import { getInviteHashLocalStorage } from './localStorage'
import { userFoundInAapeli } from './membershipChecks'

// Decide where to navigate after authentication (login or user switch)
export const getPostAuthRedirectPath = (user: any): string => {
  const inviteHash = getInviteHashLocalStorage()

  if (inviteHash) {
    return '/studentForm'
  }

  if (!userFoundInAapeli(user)) {
    return '/studentApplication'
  }

  return '/'
}
